import { FC } from 'react';
import styled, { css } from 'styled-components';

import { Tab, TabProps } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';

import { Link } from '../Link';

export const LinkStyled = styled(Link)`
  margin: 0 10px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const TabStyled = styled(Tab)`
  text-transform: uppercase;
  text-decoration: none;
  margin: 0 10px;
  height: 100%;

  ${({ theme, active }) => {
    if (theme.mainThemeMode === 'Dark') {
      if (active) {
        return css`
          color: ${Colors.White};
        `;
      }

      return css`
        color: ${Colors.Lighter};
      `;
    }

    if (theme.mainThemeMode === 'Light') {
      if (active) {
        return css`
          color: ${Colors.Darkest};
        `;
      }

      return css`
        color: ${Colors.Darkest};
      `;
    }
  }};
` as FC<TabProps>;
